import React, {Component} from 'react';
import { withRouter } from 'react-router-dom'

import AppLink from "../AppLink";

class AutocompleteList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: -1
    };

    this.onKeyUp = this.onKeyUp.bind(this);
  }

  componentDidMount() {
    window.addEventListener('keyup', this.onKeyUp)
  }

  componentWillUnmount() {
    window.removeEventListener('keyup', this.onKeyUp)
  }

  onKeyUp(e) {
    // 40 - down, 38 - up, 27 - esc
    switch (e.which) {
      case 40:
        if (this.state.selected >= this.props.list.length - 1) {
          return;
        }

        this.setState({
          //selected: this.state.selected + 1
        });
        break;
      case 38:
        if (this.state.selected <= -1) {
          return;
        }

        this.setState({
          //selected: this.state.selected - 1
        });
        break;
      case 27:
        this.setState({
          selected: -1
        });
        this.props.callback();
        break;
      default:
        break
    }
  }

  render() {
    const { list } = this.props;

    if (list.length <= 0) {
      return "";
    }

    return (
      <React.Fragment>
        <div className={'modal-fade in-content autocomplete-fade'} onClick={this.props.callback} />
        <div className={'autocomplete-list'}>
          {list.map((sugg) => {
            return (
              <AppLink className={'entry'} key={Math.random() + sugg} to={"/search?query=" + sugg}>
                {sugg}
              </AppLink>
            )
          })}
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(AutocompleteList);